import { API_ENDPOINT } from 'env'
import { asApiTypesObject } from 'redux-foundry'
import apiAction, { apiActionTypes } from './apiAction'

const fetchConversoesTempoActionTypes = apiActionTypes('conversoesTempo/API_LISTAR_CONVERSOES_TEMPO')

export const API_LISTAR_CONVERSOES_TEMPO = asApiTypesObject(fetchConversoesTempoActionTypes)

export const apiListarConversoesTempo = (data, meta = {}) => apiAction({
  endpoint: `${API_ENDPOINT}/conversoesTempo`,
  method: 'GET',
  headers: { 'Content-Type': 'application/json' },
  types: fetchConversoesTempoActionTypes,
}, { ...meta })
